import Request from '../Request';
import EndPoints from '../EndPoints';
import Methods from '../Methods';
/**
 *
 * @param data
 * @return {Promise<any>|Promise}
 */
export default (function (data) {
    var endpoint;
    // Send data to the correct enpoint, based on whether an account has to be made
    if (data.register) {
        endpoint = EndPoints.ACCEPT_INVITE_REGISTER;
    }
    else {
        endpoint = EndPoints.ACCEPT_INVITE_LOGIN;
    }
    var request = new Request({
        method: Methods.POST,
        url: endpoint,
        withCredentials: false,
        data: data
    });
    return request.execute();
});
